module.exports = __webpack_public_path__ + "img/57_16.ff44a083.png";